// PayInvoiceModal stub - Payment integrations discontinued
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';

interface PayInvoiceModalProps {
  isOpen: boolean;
  onClose: () => void;
  invoice: any;
  onPaymentSuccess?: () => void;
}

export function PayInvoiceModal({ isOpen, onClose }: PayInvoiceModalProps) {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Pagar Fatura</DialogTitle>
        </DialogHeader>
        <p className="text-muted-foreground">
          A funcionalidade de pagamento online foi descontinuada.
        </p>
      </DialogContent>
    </Dialog>
  );
}

export default PayInvoiceModal;
